import React from 'react';
import PropTypes from 'prop-types';
import pageTitleShape from './page-title-shape';
import injectPageTitle from './inject-page-title';

class PageTitleProvider extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
  };

  static childContextTypes = {
    pageTitle: pageTitleShape,
  };

  constructor(props) {
    super(props);
    this.listeners = [];
    this.childContext = {
      pageTitle: {
        title: '',
        category: '',
        set: this.set,
        subscribe: this.subscribe,
        shortTitle: '',
      },
    };
    this.state = {
      eventIndex: 0,
      errorMsg: null,
    };
  }

  getChildContext() {
    return this.childContext;
  }

  componentDidUpdate() {
    this.listeners.forEach((listener) => listener(this.state.eventIndex));
  }

  subscribe = (callback) => {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((item) => item !== callback);
    };
  };

  set = (title = '', category = '', shortTitle = '', subTitle = '') => {
    if (process.env.NODE_ENV !== 'production' &&
      !!this.childContext.pageTitle.title && !!title &&
      (!category || (!!this.childContext.pageTitle.category && !!category)) &&
      (!shortTitle || (!!this.childContext.pageTitle.shortTitle && !!shortTitle)) &&
      (!subTitle || (!!this.childContext.pageTitle.subTitle && !!subTitle))) {
      const errorMsg = 'Error: There are multiple PageTitles exist at the same time. Please fix this as it can cause problems.' +
        ` Current PageTitle: ${JSON.stringify(this.childContext)}; Next PageTitle: ${title}`;
      this.setState((state) => ({
        ...state,
        errorMsg,
      }));
      return;
    }

    if (subTitle) {
      document.title = `${title} - ${subTitle}`;
    } else if (title) {
      document.title = `Intersect - ${title}`;
    } else {
      document.title = 'Intersect';
    }
    Object.assign(this.childContext.pageTitle, { title, category, shortTitle });
    this.setState((state) => ({ eventIndex: state.eventIndex + 1 }));
  };

  render() {
    const { errorMsg } = this.state;
    if (errorMsg) {
      return (
        <div>
          <h1>Something went wrong in PageTitleProvider.</h1>
          <h3>{errorMsg}</h3>
        </div>
      );
    }
    return React.Children.only(this.props.children);
  }
}
export { injectPageTitle, pageTitleShape };
export default PageTitleProvider;
